export enum UserType {
  Admin = 'Admin',
  Borrower = 'Borrower',
  Agent = 'Agent',
  Tpo = 'TPO',
  Service = 'Service',
}
